import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalDepot } from '@/types/vehicle-withdrawal-depot'
import { AxiosResponse } from 'axios'

export function getVehicleWithdrawalDepots(): Promise<
  AxiosResponse<VehicleWithdrawalDepot[]>
> {
  return instance.get(`/vehicle-withdrawal-depot`)
}
